// Module
var code = "<div class=\"month-day-container\" ng-if=\"vm.isValidDate\"> <div class=\"month-text\"> {{::vm.month}} </div> <div class=\"day-text\"> {{::vm.day}} </div> </div> ";
// Exports
module.exports = code;